var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useEffect, useMemo, useState } from 'react';
import './marketNews.scss';
import { UuiFlexlayout } from '@aonunited/react';
import { columns } from './columnHeader/columnHeader';
import { getApplicationConfig, getDDMMYYYY } from '../../constants/utilities';
import { getMarketAndResearchData } from '../../api/marketAndResearch';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClose, faSearch } from '@fortawesome/free-solid-svg-icons';
import { MarketNewsDailog } from '../Dailog/MarketNewsDailog';
import { AonSelect } from '../../components/core/AonSingleSelect';
import AonAgGridTable from '../../components/core/AonAgGridTable/table';
var MarketNews = function () {
    var _a = React.useState([]), MarketNewsData = _a[0], setMarketNewsData = _a[1];
    var _b = React.useState(false), isLoading = _b[0], setIsLoading = _b[1];
    var _c = React.useState({
        currentPage: 1,
        totalDatacount: undefined,
        pagesize: 100,
        year: "",
        searchText: "",
        sortColumn: "publicationDate",
        sortBy: "DESC"
    }), pageConfig = _c[0], setPageConfig = _c[1];
    var _d = React.useState(""), localText = _d[0], setLocalText = _d[1];
    var _e = React.useState(false), showPublicationDailog = _e[0], setShowPublicationDailog = _e[1];
    var _f = React.useState(""), publicationId = _f[0], setPublicationId = _f[1];
    var _g = useState(window.innerHeight), currentInneHeight = _g[0], setcurrentInneHeight = _g[1];
    useEffect(function () {
        var applicationConfig = getApplicationConfig();
        var fetchdata = function () { return __awaiter(void 0, void 0, void 0, function () {
            var sortColumn, researchResponse, totalCount_1, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, 3, 4]);
                        sortColumn = pageConfig.sortColumn;
                        switch (sortColumn) {
                            case "Date":
                                sortColumn = "publicationDate";
                                break;
                            case "Title":
                                sortColumn = "publicationHeadline";
                                break;
                            case "":
                                sortColumn = "publicationDate";
                                break;
                        }
                        setIsLoading(true);
                        return [4 /*yield*/, getMarketAndResearchData({
                                PreViewReViewGuideMode: applicationConfig.applicationId,
                                PublicationTypeIds: "1",
                                Sort: "".concat(sortColumn, " ").concat(pageConfig.sortBy),
                                Page: pageConfig.currentPage,
                                PageSize: pageConfig.pagesize,
                                FreeTextSearch: pageConfig.searchText,
                                PublicationYear: pageConfig.year ? Number(pageConfig.year) : undefined
                            })];
                    case 1:
                        researchResponse = _a.sent();
                        totalCount_1 = researchResponse.headers["x-total-count"];
                        setPageConfig(function (prev) {
                            return (__assign(__assign({}, prev), { totalDatacount: totalCount_1 }));
                        });
                        setMarketNewsData(researchResponse.data.value);
                        return [3 /*break*/, 4];
                    case 2:
                        error_1 = _a.sent();
                        console.error(error_1);
                        return [3 /*break*/, 4];
                    case 3:
                        setIsLoading(false);
                        return [7 /*endfinally*/];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        fetchdata();
    }, [pageConfig.currentPage, pageConfig.pagesize, pageConfig.searchText, pageConfig.sortColumn, pageConfig.sortBy, pageConfig.year]);
    useEffect(function () {
        var updateSize = function () {
            var innerHeight = window.innerHeight;
            setcurrentInneHeight(innerHeight);
        };
        var InputListner = function (Event) {
            if (Event.key === "Enter") {
                syncLocalWithConfig(Event.target.value);
                Event === null || Event === void 0 ? void 0 : Event.preventDefault();
            }
        };
        var inputRef = document.getElementById("__marketNewsSearchInput__");
        if (inputRef) {
            inputRef.addEventListener("keydown", InputListner);
        }
        window.addEventListener("resize", updateSize);
        return function () {
            window.removeEventListener("resize", updateSize);
            inputRef.removeEventListener("keydown", InputListner);
        };
    }, []);
    var handlePageChangeRequest = function (pageConfig) {
        var page = pageConfig.detail.page;
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: "smooth"
        });
        setPageConfig(function (prev) {
            return (__assign(__assign({}, prev), { currentPage: page }));
        });
    };
    var handleChange = function (event, key) {
        setPageConfig(function (prev) {
            var _a;
            return (__assign(__assign({}, prev), (_a = {}, _a[key] = event.target.selectedValue, _a)));
        });
    };
    var syncLocalWithConfig = function (newText, isClear) {
        if (newText === void 0) { newText = ""; }
        if (isClear === void 0) { isClear = false; }
        if (isClear) {
            setPageConfig(function (prev) {
                return (__assign(__assign({}, prev), { searchText: "" }));
            });
        }
        else {
            setPageConfig(function (prev) {
                return (__assign(__assign({}, prev), { searchText: newText || localText }));
            });
        }
    };
    var handleSortingFuntions = function (sortColumn) {
        var revertSortBy = function (sBy) { return sBy === "DESC" ? "ASC" : "DESC"; };
        if (sortColumn === pageConfig.sortColumn) {
            setPageConfig(function (prev) {
                return (__assign(__assign({}, prev), { sortColumn: sortColumn, sortBy: revertSortBy(pageConfig.sortBy) }));
            });
        }
        else {
            setPageConfig(function (prev) {
                return (__assign(__assign({}, prev), { sortColumn: sortColumn, sortBy: "DESC" }));
            });
        }
    };
    var handleCross = function () {
        setLocalText("");
        syncLocalWithConfig("", true);
    };
    var handlePulicationDailog = function () {
        setShowPublicationDailog(!showPublicationDailog);
    };
    var onMarketTitleClick = function (id) {
        var data = MarketNewsData[id];
        setPublicationId(data.publicationId);
        handlePulicationDailog();
    };
    var HandleSearch = function (text) {
        setLocalText(text);
        if (!text) {
            syncLocalWithConfig("", true);
        }
    };
    var NewsDailog = useMemo(function () {
        return showPublicationDailog ? React.createElement(MarketNewsDailog, { publicationId: publicationId, onClickClose: handlePulicationDailog, showDialog: showPublicationDailog }) : null;
    }, [publicationId, showPublicationDailog]);
    return (React.createElement(UuiFlexlayout, { direction: 'column', className: 'outer-container' },
        React.createElement("div", { className: 'market-title' }, "MARKET NEWS"),
        React.createElement("div", { className: 'MarketNews-filter-wrapper' },
            React.createElement("div", { className: 'dropdown_container' },
                React.createElement("span", { style: { marginRight: "8px", marginBottom: "10px", color: "grey" } }, "Show articles from "),
                React.createElement(AonSelect, { defaultValue: 'Year', selectedValue: pageConfig.year, handelChecked: function (event) { return handleChange(event, "year"); }, options: __spreadArray([{ label: "Year", value: "" }], Array.from({ length: 25 }, function (_, index) {
                        var year = new Date().getFullYear() - index;
                        return ({ label: year.toString(), value: year.toString() });
                    }), true) })),
            React.createElement("div", { className: "market-input-container" },
                React.createElement("span", { style: { marginRight: "5px", color: 'grey' } }, "Search"),
                React.createElement("div", { className: 'text-input-field' },
                    React.createElement("input", { className: 'text-input', onChange: function (event) { return HandleSearch(event.target.value); }, value: localText, type: "text", name: "", id: "__marketNewsSearchInput__", placeholder: 'Search by topic or company' }),
                    localText && React.createElement(FontAwesomeIcon, { onClick: handleCross, className: 'text-icon', icon: faClose }),
                    React.createElement(FontAwesomeIcon, { onClick: syncLocalWithConfig, className: 'text-icon', icon: faSearch })))),
        React.createElement("div", { style: { marginInline: "20px" } },
            React.createElement(AonAgGridTable, { rowData: MarketNewsData.map(function (data) { return ({
                    Date: getDDMMYYYY(data.publicationDate),
                    Title: React.createElement("a", { href: "" }, data.publicationHeadline)
                }); }), columns: columns(handleSortingFuntions, pageConfig.sortColumn, pageConfig.sortBy, isLoading, onMarketTitleClick), height: currentInneHeight, loading: isLoading, pagination: true, currentPage: pageConfig.currentPage, totalCount: pageConfig.totalDatacount, handleSorting: handleSortingFuntions, pageSize: pageConfig.pagesize, onPageChange: handlePageChangeRequest })),
        NewsDailog));
};
export default MarketNews;
